export default __webpack_public_path__ + "static/media/company.7841a5db.svg";